<template>
  <div class="main">
    <div class="wrapper">
      <h1>Добро пожаловать!</h1>
      <h2>kandinskiy.com v2.0</h2>
      <div class="main-introduction">
        <p>Сайт не является коммерческим продуктом. Основная цель создания - оттачивание и демонстрация знаний, проведение эксперементов, наработка собственных решений, использование в качестве записной книжки.</p>
        <p>Данный сайт сделан с уклоном во фронтенд: одностраничный, выполнен на Vue.js</p>
      </div>
      <MainLinks></MainLinks>
    </div>
  </div>
</template>

<script>
import MainLinks from '../components/MainLinks'

export default {
  name: "Main",
  components: { MainLinks }
}
</script>

<style lang="scss" scoped>
  .main {
    position: relative;

    &-introduction {
      margin-top: 20px;
    }
  }
</style>
